/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';

/**
 * 
 * @export
 * @interface GetEmailAddressDto
 */
export interface GetEmailAddressDto {
    /**
     * 
     * @type {string}
     * @memberof GetEmailAddressDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailAddressDto
     */
    emailsTo: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailAddressDto
     */
    emailsDw: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEmailAddressDto
     */
    emailFrom: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetEmailAddressDto
     */
    comment: string;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetEmailAddressDto
     */
    client: GetClientDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmailAddressDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetEmailAddressDto interface.
 */
export function instanceOfGetEmailAddressDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "emailsTo" in value;
    isInstance = isInstance && "emailsDw" in value;
    isInstance = isInstance && "emailFrom" in value;
    isInstance = isInstance && "comment" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetEmailAddressDtoFromJSON(json: any): GetEmailAddressDto {
    return GetEmailAddressDtoFromJSONTyped(json, false);
}

export function GetEmailAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmailAddressDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'emailsTo': json['emailsTo'],
        'emailsDw': json['emailsDw'],
        'emailFrom': GetDictionaryDtoFromJSON(json['emailFrom']),
        'comment': json['comment'],
        'client': GetClientDtoFromJSON(json['client']),
        'active': json['active'],
    };
}

export function GetEmailAddressDtoToJSON(value?: GetEmailAddressDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'emailsTo': value.emailsTo,
        'emailsDw': value.emailsDw,
        'emailFrom': GetDictionaryDtoToJSON(value.emailFrom),
        'comment': value.comment,
        'client': GetClientDtoToJSON(value.client),
        'active': value.active,
    };
}

